import { SAVE_LEVEL } from '../constants/Level';
import { envValue } from '../../config/envUtils';
const SOURCEURL = envValue('SOURCEURL');

export class Service {
    /**
     * Helper function to decide which params should be included in service call
     * @param chainId
     * @param hotelId
     * @param brandcode
     * @param saveLevel
     * @returns {string}
     */
    static paramProxy(chainId, hotelId, brandcode = null, saveLevel = SAVE_LEVEL.HOTEL) {
        const params = [`chainid=${chainId}`];

        if (saveLevel === SAVE_LEVEL.HOTEL) {
            params.push(`hotelid=${hotelId}`);
        }
        // TODO: brand level
        // `brandcode=${brandcode}`
        return params.join('&');
    }

    static setActive(chainId, hotelId, saveLevel = SAVE_LEVEL.HOTEL) {}

    static fileParamProxy(chainId, hotelId, brandcode = null, saveLevel = SAVE_LEVEL.HOTEL, filename, category) {
        const params = [`chainid=${chainId}`];
        if (saveLevel === SAVE_LEVEL.HOTEL) {
            params.push(`hotelid=${hotelId}`);
        }
        // TODO: brand level
        // `brandcode=${brandcode}`
        if (category) {
            params.push(`category=${category}`);
        }
        if (filename) {
            params.push(`filename=${filename}`);
        }
        return params.join('&');
    }

    static assetUrl(
        chainId,
        hotelId,
        brandcode = null,
        saveLevel = SAVE_LEVEL.HOTEL,
        filename,
        relative = true,
        category
    ) {
        const isGcpEnvironment = /t1|t2|l1|l2|t3|t4|t4b|c1|c2|i1|e2|p1|p2|p4/.test(envValue('ENV_CODE'));
        return encodeURI(
            `${!relative ? `${SOURCEURL}/` : ''}${
                isGcpEnvironment ? 'shs-bedesigner-services/' : ''
            }assets/chain/${chainId}${saveLevel === SAVE_LEVEL.HOTEL ? `/hotel/${hotelId}` : ''}/fileStorage${
                category ? `/${category.toLowerCase()}` : ''
            }/${filename}`
        );
    }
}

Service.contenttype = '';



// WEBPACK FOOTER //
// ./src/services/Service.js